// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@tps/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { orderHistoryTableStyles } from "@tps/Overrides/Widgets/OrderHistory/OrderHistoryTable";
import { css } from "styled-components";

orderHistoryTableStyles.reorderButton = {
    variant: "secondary",
    sizeVariant: "medium",
    css: css`
        width: 100%;
    `,
};

orderHistoryTableStyles.reorderButtonSpinner = {
    size: 30,
    css: css`
        margin-left: auto;
        margin-right: auto;
        display: block;
    `,
};

orderHistoryTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

orderHistoryTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

orderHistoryTableStyles.orderNumberHeader = {
    tight: true,
};

orderHistoryTableStyles.orderDateHeader = {
    tight: true,
};

orderHistoryTableStyles.statusHeader = {
    tight: true,
};

orderHistoryTableStyles.orderTypeHeader = {
    tight: true,
};

orderHistoryTableStyles.orderedByHeader = {
    tight: true,
};

orderHistoryTableStyles.customerPOHeader = {
    tight: true,
};

orderHistoryTableStyles.shipToCells = {
    typographyProps: {
        ellipsis: true,
        css: css`
            display: block;
            max-width: 400px;
        `,
    },
};

orderHistoryTableStyles.orderTotalCells = {
    alignX: "left",
};

// XNG-Container
orderHistoryTableStyles.container = {
    css: css`
        overflow: hidden;
    `,
};
orderHistoryTableStyles.reorderCells = {
    css: css`
        vertical-align: middle;
    `,
};
